import React from "react";
import { withTheme } from "styled-components";
import IconButton from "@irati/ui/src/Button/IconButton";
import { IconTypes } from "@irati/ui/src/Icon";
import favouritesService from "@irati/deals/services/favourites";
import IsDealFavourited from "@irati/deals/apollo/query/IsDealFavourited";
var FavouriteButton = function (_a) {
    var deal = _a.deal, className = _a.className, _b = _a.iconSize, iconSize = _b === void 0 ? 32 : _b, onChange = _a.onChange, theme = _a.theme;
    var onClick = function (isFavourite, event) {
        event.preventDefault();
        event.stopPropagation();
        if (onChange) {
            onChange(!isFavourite);
        }
        return isFavourite ? favouritesService.remove(deal) : favouritesService.add(deal);
    };
    return (React.createElement(IsDealFavourited, { dealId: deal.uuid }, function (_a) {
        var isFavourite = _a.isFavourite;
        return (React.createElement(IconButton, { className: className, icon: isFavourite ? IconTypes.favouriteFill : IconTypes.favourite, size: iconSize, color: theme.colors.utility.white, onClick: function (e) { return onClick(isFavourite, e); } }));
    }));
};
export default withTheme(FavouriteButton);
